<template>
  <div>
    <div class="online-button" @click.prevent="$emit('click-toggle')">
      <div class="online-button-icons-box">
        <svg
          v-if="widgetVisible !== true"
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          width="34px"
          height="31px"
          viewBox="196.042 229.698 34 31"
          enable-background="new 196.042 229.698 34 31"
          xml:space="preserve"
        >
          <g transform="translate(0,-288.53332)">
            <path
              fill="#fff"
              d="M196.741,518.231c-0.932-0.004-0.932,1.419,0,1.414h3.511c0.895,0,1.684,0.583,1.962,1.456l4.743,14.853
		l-2.266,1.609c-0.614,0.437-1.034,1.163-1.034,2.017v0.135c0,1.353,1.095,2.465,2.425,2.465h23.204
		c1.007,0.092,1.007-1.495,0-1.403h-23.204c-0.582,0-1.045-0.471-1.045-1.062v-0.135c0-0.293,0.264-0.73,0.452-0.864l2.558-1.819
		h16.634c0.896,0,1.689-0.588,1.965-1.456l3.243-10.214c0.427-1.344-0.584-2.765-1.973-2.765h-20.105
		c-1.007-0.091-1.007,1.496,0,1.403h20.105c0.483,0,0.803,0.449,0.652,0.925l-0.602,1.893h-17.446
		c-0.927,0.048-0.854,1.463,0.073,1.414h16.924l-0.896,2.82h-13.326c-0.852,0.109-0.787,1.384,0.07,1.403h12.813l-0.853,2.683
		c-0.094,0.294-0.346,0.49-0.645,0.49h-16.42l-4.726-14.831c-0.462-1.445-1.792-2.432-3.284-2.432L196.741,518.231z"
            />
            <path
              fill="#fff"
              d="M209.9,543.595c-1.523,0-2.773,1.271-2.773,2.818s1.25,2.818,2.773,2.818c1.522,0,2.763-1.271,2.763-2.818
		C212.661,544.865,211.422,543.595,209.9,543.595L209.9,543.595z M209.9,544.998c0.773,0,1.381,0.628,1.381,1.415
		s-0.607,1.404-1.381,1.404c-0.774,0-1.392-0.617-1.392-1.404S209.126,544.998,209.9,544.998z"
            />
            <path
              fill="#fff"
              d="M223.752,543.595c-1.522,0-2.772,1.271-2.772,2.818s1.25,2.818,2.772,2.818s2.772-1.271,2.772-2.818
		S225.275,543.595,223.752,543.595z M223.752,544.998c0.773,0,1.392,0.628,1.392,1.415s-0.618,1.404-1.392,1.404
		s-1.381-0.617-1.381-1.404S222.979,544.998,223.752,544.998z"
            />
          </g>
        </svg>
        <img
          v-if="widgetVisible"
          src="@/components/SliderBuyOnline2020/icon/close.png"
        />
      </div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16.024"
        height="16"
        viewBox="0 0 16.024 16"
      >
        <defs />
        <path
          class="a"
          d="M14,13.2a2.4,2.4,0,1,1-2.264,1.6H8.26a2.4,2.4,0,1,1-4.5-.08A2.4,2.4,0,0,1,4.4,10V3.6H2.8A.8.8,0,0,1,2.8,2H5.2a.8.8,0,0,1,.8.8v.8H17.2a.8.8,0,0,1,.72,1.16l-3.2,6.4a.8.8,0,0,1-.72.44H4.4a.8.8,0,0,0,0,1.6ZM6,10h7.5l2.4-4.8H6Zm0,6.4a.8.8,0,1,0-.8-.8A.8.8,0,0,0,6,16.4Zm8,0a.8.8,0,1,0-.8-.8A.8.8,0,0,0,14,16.4Z"
          transform="translate(-1.978 -2)"
        />
      </svg>
      <div class="button-wrapper">
        <span class="button-text">{{ handlerText }}</span>
      </div>
    </div>
    <div
      class="online-button-mobile"
      v-scroll-to="{ el: '#element', offset: -235 }"
    >
      <svg
        v-if="widgetVisible !== true"
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        width="34px"
        height="31px"
        viewBox="196.042 229.698 34 31"
        enable-background="new 196.042 229.698 34 31"
        xml:space="preserve"
      >
        <g transform="translate(0,-288.53332)">
          <path
            fill="#fff"
            d="M196.741,518.231c-0.932-0.004-0.932,1.419,0,1.414h3.511c0.895,0,1.684,0.583,1.962,1.456l4.743,14.853
		l-2.266,1.609c-0.614,0.437-1.034,1.163-1.034,2.017v0.135c0,1.353,1.095,2.465,2.425,2.465h23.204
		c1.007,0.092,1.007-1.495,0-1.403h-23.204c-0.582,0-1.045-0.471-1.045-1.062v-0.135c0-0.293,0.264-0.73,0.452-0.864l2.558-1.819
		h16.634c0.896,0,1.689-0.588,1.965-1.456l3.243-10.214c0.427-1.344-0.584-2.765-1.973-2.765h-20.105
		c-1.007-0.091-1.007,1.496,0,1.403h20.105c0.483,0,0.803,0.449,0.652,0.925l-0.602,1.893h-17.446
		c-0.927,0.048-0.854,1.463,0.073,1.414h16.924l-0.896,2.82h-13.326c-0.852,0.109-0.787,1.384,0.07,1.403h12.813l-0.853,2.683
		c-0.094,0.294-0.346,0.49-0.645,0.49h-16.42l-4.726-14.831c-0.462-1.445-1.792-2.432-3.284-2.432L196.741,518.231z"
          />
          <path
            fill="#fff"
            d="M209.9,543.595c-1.523,0-2.773,1.271-2.773,2.818s1.25,2.818,2.773,2.818c1.522,0,2.763-1.271,2.763-2.818
		C212.661,544.865,211.422,543.595,209.9,543.595L209.9,543.595z M209.9,544.998c0.773,0,1.381,0.628,1.381,1.415
		s-0.607,1.404-1.381,1.404c-0.774,0-1.392-0.617-1.392-1.404S209.126,544.998,209.9,544.998z"
          />
          <path
            fill="#fff"
            d="M223.752,543.595c-1.522,0-2.772,1.271-2.772,2.818s1.25,2.818,2.772,2.818s2.772-1.271,2.772-2.818
		S225.275,543.595,223.752,543.595z M223.752,544.998c0.773,0,1.392,0.628,1.392,1.415s-0.618,1.404-1.392,1.404
		s-1.381-0.617-1.381-1.404S222.979,544.998,223.752,544.998z"
          />
        </g>
      </svg>
    </div>
  </div>
</template>
<script>
export default {
props: ["handlerText", "widgetVisible","i18n"],
  data() {
    return {
      // widgetVisible: false,
    };
  },
};
</script>
<style lang="scss">
.online-button-mobile {
  background: #e41429;
  width: 50px;
  height: 50px;
  border-radius: 6px;
  text-align: center;
  position: fixed;
  bottom: 10px;
  right: 10px;
  z-index: 999;
  display: none;
  cursor:pointer;
}
.online-button-mobile svg {
  margin-top: 10px;
  margin-left: -2px;
}
.online-button {
  //   font-family: "SohoGothicPro", Arial;
  position: fixed;
  background-color: #e41429;
  top: 60px;
  right: 0px;
  z-index: 999;
  padding: 100px 3px 100px 6px;
  cursor: pointer;
  background-position: 27px 100px;
  -webkit-border-radius: 0 0 15px 15px;
  border-radius: 0 0 15px 15px;
  transition: 0.2s ease-in-out;
  transform: translateY(-20px);

  .online-button-icons-box {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
  }

  .button-wrapper {
    transform: rotate(90deg);
    transform-origin: center center 0;
    margin-top: 30px;
    span {
      color: #fff;
      font-size: 14px;
      font-weight: 900;
      text-transform: uppercase;
      display: block;
      width: 83px;
      white-space: nowrap;
    }
  }
}
.online-button:hover {
  transform: translateY(10px);
}
@media screen and (max-width: 980px) {
  .online-button {
    display: none;
  }
  .online-button-mobile {
    display: block;
  }
}
</style>
